import * as React from 'react';
import { Parameters, PFTResults, StudyRelevantParameters, VolumetricParameter, FlowParameter, DiffusingCapacityParameter, PressureParameter } from '../../PulmonaryFunctionTests/Shared/PFTAPITypes';
import ParameterResult from '../../PulmonaryFunctionTests/Shared/ParameterResult';
import ResultsGroupHeading from './ResultsGroupHeading';

export interface RepeatabilityTableProps {
    results: PFTResults;
    isLoading?: boolean;
    isRejected?: boolean;
    showConfiguredParametersOnly?: boolean;
    studyRelevantParameters?: StudyRelevantParameters;
    pressureSessionType?: 'MIP' | 'MEP' | 'SNIP';
}

const RepeatabilityTable = (props: RepeatabilityTableProps) => {
    var parameters: Parameters;
    if (props.showConfiguredParametersOnly) {
        parameters = props.studyRelevantParameters.RepeatabilityParameters ?? props.studyRelevantParameters.DefaultRepeatabilityParameters;
    } else {
        parameters = props.results.DisplayRepeatabilityParameters;
    }

    // HACK: This extra FEV1 & FVC comparison is needed due to an upstream issue where the unit type is set incorrectly
    const displayNameHack = (dp: VolumetricParameter | FlowParameter | DiffusingCapacityParameter | PressureParameter) => {
        if (dp.Identifier === "FVC")
            return "FVC (ml)";

        if (dp.Identifier === "FEV1")
            return "FEV1 (ml)";

        if (dp.Identifier === "VC")
            return "VC (L)";

        if (dp.Identifier === "IC")
            return "IC (L)";

        if (props.pressureSessionType && props.pressureSessionType !== 'SNIP')
            return dp.DisplayName.replace('MIP/MEP', props.pressureSessionType);

        return dp.DisplayName;
    }

    const IsRejected = (overreaderAcceptability?: boolean, technicianAcceptability?: boolean) => {
        if (overreaderAcceptability === true) {
            return false;
        }

        if (overreaderAcceptability === false) {
            return true;
        }

        if (technicianAcceptability === true) {
            return false;
        }

        return true;
    }

    return (
        <>
            <ResultsGroupHeading resultsCount={props.results.TestResults.length} title="Repeatability" />

            {
                parameters.map(dp => {
                    return (
                        <tr key={`Repeatability${dp.Identifier}${dp.Units}`}>
                            <td>{displayNameHack(dp)}</td>
                            {
                                props.results.TestResults.map((tr, trIndex) => {
                                    return <ParameterResult
                                               isRejected={IsRejected(tr.OverreaderAcceptability, tr.TechnicianAcceptability)}
                                               isLoading={props.isLoading}
                                               key={`RepeatabilityResult${dp}${tr.TestId}`}
                                               results={props.results.TestResults}
                                               testIndex={trIndex} 
                                               testNumber={tr.TestNumber}
                                               parameterId={dp.ParameterType}
                                               units={dp.Units}
                                               isRepeatability={true}
                                               automationSection='repeatability'
                                           />
                                })
                            }
                            <td></td>
                        </tr>
                    );
                })
            }
        </>
    );
}

export default RepeatabilityTable;
